import { useEffect } from 'react';
import { LoadingOverlay } from '@optimus-web/core';
import { Loader } from './Loader';

interface OverlayProps {
    fixed?: boolean;
    show?: boolean;
}

export const OverlayedLoader = (props: OverlayProps) => {
    useEffect(() => {
        if (document.activeElement instanceof HTMLElement) {
            document.activeElement.blur();
        }
    }, []);

    return <LoadingOverlay {...props}>{props.show && <Loader />}</LoadingOverlay>;
};
